import * as React from "react";

import { default as ReactSelect } from "react-select";

import { CommonControlProps } from "@common/components/Atoms/FormInputs/commonControlProps";
import { IconFrown } from "@common/components/Atoms/Icons";
import { SelectOption } from "@common/models/SelectOption";

const ASYNC_DELAY = 200;

interface SelectProps extends CommonControlProps {
    clearable?: boolean
    description?: string
    id?: string
    inputPattern?: string
    inputType?: "text" | "number" | "tel" | "email"
    isValid: boolean
    label?: string
    multi?: boolean
    name: string
    options?: any
    remoteOptionsMethod?: (input: any) => Promise<any>
    selectRef?: any
    simpleValue?: boolean
    validationMessages: string[]
    value?: any
}

interface SelectState {
    locationOptions: SelectOption[]
    showMessage: boolean
}

export class Select extends React.Component<SelectProps, SelectState> {

    static defaultProps = {
        clearable: true,
        options: [],
        multi: true,
        name: "",
        inputType: "text",
        isValid: true,
        simpleValue: true,
        validationMessages: [],
    }

    constructor(props: SelectProps) {
        super(props);
        this.state = {
            locationOptions: [],
            showMessage: false,
        };

        this.onChange = this.onChange.bind(this);
        this.getOptions = this.getOptions.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }

    onChange(value) {
        if(this.props.onChange) this.props.onChange(this.props.name, value);
    }

    onBlur() {
        this.setState({ showMessage: false });
        if (this.props.onBlur) this.props.onBlur(this.props.name);
    }

    onFocus() {
        this.setState({ showMessage: true });
        if (this.props.onFocus) this.props.onFocus(this.props.name);
    }

    getOptions(input, callback) {
        if (input.length > 2) {
            const getGuts = () => {
                const data = {
                    options: this.state.locationOptions,
                    complete: true
                };
                setTimeout(() => {
                    callback(null, data);
                }, ASYNC_DELAY);
            };

            if (this.props.remoteOptionsMethod) {

                let selectedValues: any[] = [];
                if(!!this.props.value && (this.props.value instanceof Array)) {
                    selectedValues = this.props.value.map(x => x.value)
                }

                this.props.remoteOptionsMethod(input).then(opts => {
                    const filteredOpts = opts.filter((val, ind) => {
                        const valstr = val.value.toString();
                        return selectedValues.indexOf(valstr) < 0;
                    });
                    this.setState(
                        {
                            locationOptions: filteredOpts
                        },
                        getGuts
                    );
                });
            }
        } else callback(null, { options: [], complete: true });
    }

    render() {
        const isAsync = !!this.props.remoteOptionsMethod;

        const inputRenderer = inputProps => {
            const checkAllowedInput = keyPressEvent => {
                if (this.props.inputType !== "number") {
                    return; // Allow the input to pass through
                }
                const keyCharCode = keyPressEvent.charCode;
                if (/\d/.test(String.fromCharCode(keyCharCode))) {
                    // it's a nubmer, so Allow the input to pass through
                    return;
                }

                // if we made it here, don't allow the input to go through...
                keyPressEvent.preventDefault();
            };

            return (
                <div
                    id={"select-div_" + this.props.name}
                    className={`Select-input c-select c-select--${this.props.inputType}`}
                    key="input-wrap"
                    style={{ display: "inline-block" }}>
                    <input
                        {...inputProps}
                        onKeyPress={checkAllowedInput}
                        id={"select-input_" + this.props.name}
                        type={this.props.inputType}
                        pattern={this.props.inputPattern}
                    />
                </div>
            );
        };

        const commonSelectProps = {
            multi: this.props.multi,
            value: this.props.value,
            onChange: this.onChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            removeSelected: this.props.multi,
            clearable: this.props.clearable,
            className: "c-select",
            inputRenderer,
            id: "select_" + this.props.name,
            filterOptions: false,
        };
        const selectProps = isAsync
            ? {
                ...commonSelectProps,
                loadOptions: this.getOptions
            }
            : {
                ...commonSelectProps,
                closeOnSelect: true,
                simpleValue: this.props.simpleValue,
                options: this.props.options
            };

        return (
            <div className="c-block">
                <div
                    className={
                        "c-control c-control--text " + (!this.props.isValid ? "has-error" : "")
                    }>
                    {this.props.label && (
                        <div className="c-control__label">
                            <label htmlFor={"select-input_" + this.props.name}>{this.props.label}</label>
                            {this.props.description && <p>{this.props.description}</p>}
                        </div>
                    )}
                    <div
                        className={
                            "c-control__wrapper selectInput " +
                            (!this.props.isValid ? "has-error" : "")
                        }>
                        {isAsync && <ReactSelect.Async {...selectProps} ref={this.props.selectRef} />}
                        {!isAsync && <ReactSelect {...selectProps} ref={this.props.selectRef} />}
                    </div>
                    {!this.props.isValid && (
                        <div className="c-control__message">
                            <IconFrown />
                            {this.props.validationMessages.map((msg, ind) => (
                                <span key={ind}>{msg + " "}</span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

